export const upcomingEventJson = {
  page: {
    body: {
      container: { style: { 'background-color': '#FFFFFF' } },
      content: {
        computedStyle: { linkColor: '#ff819c', messageBackgroundColor: 'transparent', messageWidth: '700px' },
        style: { color: '#000000', 'font-family': "Arial, 'Helvetica Neue', Helvetica, sans-serif" },
      },
      type: 'mailup-bee-page-properties',
      webFonts: [],
    },
    description: 'empty-dutchie-template',
    rows: [
      {
        columns: [
          {
            'grid-columns': 12,
            modules: [
              {
                descriptor: {
                  computedStyle: { class: 'center fixedwidth', hideContentOnMobile: false, width: '124px' },
                  image: {
                    alt: '',
                    height: '140px',
                    href: '',
                    percWidth: 20,
                    prefix: '',
                    src: 'https://d15k2d11r6t6rl.cloudfront.net/pub/c524/b1oxpgm8/yub/3ji/j88/Dispo%20Logos.png',
                    target: '_blank',
                    width: '252px',
                  },
                  style: {
                    'border-radius': '0px',
                    'padding-bottom': '40px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-image',
                uuid: '9885ed9b-2ac2-43eb-9409-e3071e8551cf',
              },
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#c1d3f1',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '30px',
                      'font-weight': '700',
                      'letter-spacing': '4px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: '<span class="tinyMce-placeholder">2024</span>',
                    title: 'h1',
                  },
                  mobileStyle: { 'font-size': '20px' },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: 'fcb07abd-9e96-4f98-89a6-2c78b162b534',
              },
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#ffffff',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '48px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: '<span class="tinyMce-placeholder">Grand Opening!</span>',
                    title: 'h1',
                  },
                  mobileStyle: { 'font-size': '32px' },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: 'b6cef0ad-05e0-44e3-b17a-ef5edf8754a1',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '16px',
              'padding-left': '40px',
              'padding-right': '40px',
              'padding-top': '60px',
            },
            uuid: 'cb911f58-1e3e-4d35-9717-73e278881987',
          },
        ],
        container: {
          style: {
            'background-color': '#10304d',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            'border-radius': '0px',
            color: '#333',
            width: '700px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'one-column-empty',
        uuid: '4bf4a6fc-45d2-41ae-a96c-1604a93d8e16',
      },
      {
        columns: [
          {
            'grid-columns': 6,
            modules: [
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#c1d3f1',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '14px',
                      'font-weight': '700',
                      'letter-spacing': '2px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: '<span class="tinyMce-placeholder">WHEN</span>',
                    title: 'h1',
                  },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: '1bb026d9-3447-4f54-83e5-4f5a5dbda856',
              },
              {
                descriptor: {
                  computedStyle: {
                    hideContentOnAmp: false,
                    hideContentOnDesktop: false,
                    hideContentOnHtml: false,
                    hideContentOnMobile: false,
                  },
                  paragraph: {
                    computedStyle: { linkColor: '#0075e0', paragraphSpacing: '16px' },
                    html: '<p>Friday <br/>November 8, 2024</p>',
                    style: {
                      color: '#ffffff',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '16px',
                      'font-weight': '400',
                      'letter-spacing': '0px',
                      'line-height': '150%',
                      'text-align': 'center',
                    },
                  },
                  style: {
                    'padding-bottom': '0px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-paragraph',
                uuid: '9881ab15-8744-4c55-bec1-b02363830522',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '1px dashed #a5b5c4',
              'border-top': '0px solid transparent',
              'padding-bottom': '32px',
              'padding-left': '32px',
              'padding-right': '32px',
              'padding-top': '32px',
            },
            uuid: 'afb0a0f5-9f24-4795-82d0-42a9d4901084',
          },
          {
            'grid-columns': 6,
            modules: [
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#c1d3f1',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '14px',
                      'font-weight': '700',
                      'letter-spacing': '2px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: '<span class="tinyMce-placeholder">WHERE</span>',
                    title: 'h1',
                  },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: '528a826f-f525-4d25-ba21-a5dc50a8c059',
              },
              {
                descriptor: {
                  computedStyle: {
                    hideContentOnAmp: false,
                    hideContentOnDesktop: false,
                    hideContentOnHtml: false,
                    hideContentOnMobile: false,
                  },
                  paragraph: {
                    computedStyle: { linkColor: '#0075e0', paragraphSpacing: '16px' },
                    html: '<p>1234 Washington St.<br/>City, State, Zip</p>',
                    style: {
                      color: '#ffffff',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '16px',
                      'font-weight': '400',
                      'letter-spacing': '0px',
                      'line-height': '150%',
                      'text-align': 'center',
                    },
                  },
                  style: {
                    'padding-bottom': '0px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-paragraph',
                uuid: '11f93390-e3a0-4c46-ad42-a48db582787c',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '32px',
              'padding-left': '32px',
              'padding-right': '32px',
              'padding-top': '32px',
            },
            uuid: '45f5116e-f661-492c-a7fa-b7d98b990116',
          },
        ],
        container: {
          style: {
            'background-color': '#10304d',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            'border-bottom': '1px dashed #a5b5c4',
            'border-left': '1px dashed #a5b5c4',
            'border-radius': '4px',
            'border-right': '1px dashed #a5b5c4',
            'border-top': '1px dashed #a5b5c4',
            color: '#000000',
            width: '700px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'two-columns-empty',
        uuid: 'cf337d9b-8401-44aa-9a03-ffba06c056f1',
      },
      {
        columns: [
          {
            'grid-columns': 12,
            mobileStyle: {
              'padding-bottom': '48px',
              'padding-left': '24px',
              'padding-right': '24px',
              'padding-top': '32px',
            },
            modules: [
              {
                descriptor: {
                  computedStyle: {
                    class: 'center fixedwidth fullwidthOnMobile',
                    hideContentOnMobile: false,
                    width: '620px',
                  },
                  image: {
                    alt: '',
                    height: '721px',
                    href: '',
                    percWidth: 100,
                    prefix: '',
                    src: 'https://d15k2d11r6t6rl.cloudfront.net/pub/c524/b1oxpgm8/8a3/29a/cye/Event_Photo.jpg',
                    target: '_blank',
                    width: '1200px',
                  },
                  style: {
                    'border-radius': '0px',
                    'padding-bottom': '0px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-image',
                uuid: '24f74b19-ffe1-4d54-9cb6-5f4a2f556fde',
              },
              {
                descriptor: {
                  button: {
                    label:
                      '<div class="txtTinyMce-wrapper" style="" data-mce-style=""><p style="word-break:break-word;" data-mce-style="word-break:break-word;">RSVP Here</p></div>',
                    percWidth: 52,
                    style: {
                      'background-color': '#0075e0',
                      'border-bottom': '0px solid transparent',
                      'border-left': '0px solid transparent',
                      'border-radius': '4px',
                      'border-right': '0px solid transparent',
                      'border-top': '0px solid transparent',
                      color: '#ffffff',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '16px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '200%',
                      'max-width': '100%',
                      'padding-bottom': '12px',
                      'padding-left': '20px',
                      'padding-right': '20px',
                      'padding-top': '12px',
                      width: '60%',
                    },
                    target: '_blank',
                  },
                  computedStyle: { height: 56, hideContentOnMobile: false, width: 324 },
                  mobileStyle: {
                    'padding-bottom': '0px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '32px',
                  },
                  style: {
                    'padding-bottom': '0px',
                    'padding-left': '40px',
                    'padding-right': '40px',
                    'padding-top': '32px',
                    'text-align': 'center',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-button',
                uuid: '967d587f-3904-48e9-bcf0-4142f3bfa711',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '48px',
              'padding-left': '40px',
              'padding-right': '40px',
              'padding-top': '32px',
            },
            uuid: 'eae2661e-425f-4c1e-b86e-49becd796c82',
          },
        ],
        container: {
          style: {
            'background-color': '#10304d',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            'border-bottom': '0px solid transparent',
            'border-left': '0px solid transparent',
            'border-radius': '0px',
            'border-right': '0px solid transparent',
            'border-top': '0px solid transparent',
            color: '#000000',
            width: '700px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'one-column-empty',
        uuid: 'f7c2ea85-effb-439d-bf1d-f0c82aeb735f',
      },
      {
        columns: [
          {
            'grid-columns': 12,
            mobileStyle: {
              'padding-bottom': '24px',
              'padding-left': '24px',
              'padding-right': '24px',
              'padding-top': '24px',
            },
            modules: [
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#0b192c',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '32px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: '<span class="tinyMce-placeholder">Featured Brands</span>',
                    title: 'h2',
                  },
                  mobileStyle: { 'font-size': '24px' },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: 'a5a90346-33a6-49ce-985f-df62ffca97c2',
              },
              {
                descriptor: {
                  computedStyle: {
                    hideContentOnAmp: false,
                    hideContentOnDesktop: false,
                    hideContentOnHtml: false,
                    hideContentOnMobile: false,
                  },
                  mobileStyle: { 'font-size': '16px' },
                  paragraph: {
                    computedStyle: { linkColor: '#0075e0', paragraphSpacing: '16px' },
                    html: '<p>Get 20% off select brands at the event.</p>',
                    style: {
                      color: '#646d72',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '20px',
                      'font-weight': '400',
                      'letter-spacing': '0px',
                      'line-height': '150%',
                      'text-align': 'center',
                    },
                  },
                  style: {
                    'padding-bottom': '0px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-paragraph',
                uuid: '92fc30f5-d9ef-42f1-a2f8-6ef297533b49',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '40px',
              'padding-left': '40px',
              'padding-right': '40px',
              'padding-top': '40px',
            },
            uuid: 'f8c303aa-200e-4cd2-ab25-ca7afd04983c',
          },
        ],
        container: {
          style: {
            'background-color': '#ffffff',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            'border-bottom': '0px solid transparent',
            'border-left': '0px solid transparent',
            'border-radius': '0px',
            'border-right': '0px solid transparent',
            'border-top': '0px solid transparent',
            color: '#000000',
            width: '700px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'one-column-empty',
        uuid: '60561011-3dd1-42a8-9d87-b5fd7aea5bc6',
      },
      {
        columns: [
          {
            'grid-columns': 6,
            modules: [
              {
                descriptor: {
                  computedStyle: {
                    class: 'center fixedwidth fullwidthOnMobile',
                    hideContentOnMobile: false,
                    width: '210px',
                  },
                  image: {
                    alt: '',
                    height: '541px',
                    href: '',
                    percWidth: 60,
                    prefix: '',
                    src: 'https://d15k2d11r6t6rl.cloudfront.net/pub/c524/b1oxpgm8/p5a/0yr/9cn/Brand-1.png',
                    target: '_blank',
                    width: '540px',
                  },
                  mobileStyle: {
                    'padding-bottom': '48px',
                    'padding-left': '48px',
                    'padding-right': '48px',
                    'padding-top': '48px',
                  },
                  style: {
                    'border-radius': '0px',
                    'padding-bottom': '16px',
                    'padding-left': '16px',
                    'padding-right': '16px',
                    'padding-top': '16px',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-image',
                uuid: 'd8205108-a29a-4a1f-a0e4-b3127b055a8a',
              },
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#121516',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '20px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: 'Emerald Grov<span class="mce-nbsp-wrap">&nbsp;</span>e',
                    title: 'h1',
                  },
                  mobileStyle: { 'font-size': '16px' },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '16px',
                    'padding-right': '16px',
                    'padding-top': '16px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: 'a3b7a1e7-3790-4678-9659-577f85fd1ecd',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '32px',
              'padding-left': '0px',
              'padding-right': '0px',
              'padding-top': '0px',
            },
            uuid: 'a9d6c96f-e86b-484d-9f8c-772024ca440c',
          },
          {
            'grid-columns': 6,
            modules: [
              {
                descriptor: {
                  computedStyle: {
                    class: 'center fixedwidth fullwidthOnMobile',
                    hideContentOnMobile: false,
                    width: '210px',
                  },
                  image: {
                    alt: '',
                    height: '541px',
                    href: '',
                    percWidth: 60,
                    prefix: '',
                    src: 'https://d15k2d11r6t6rl.cloudfront.net/pub/c524/b1oxpgm8/6r2/x4n/1x1/Brand-2.png',
                    target: '_blank',
                    width: '540px',
                  },
                  mobileStyle: {
                    'padding-bottom': '48px',
                    'padding-left': '48px',
                    'padding-right': '48px',
                    'padding-top': '48px',
                  },
                  style: {
                    'border-radius': '0px',
                    'padding-bottom': '16px',
                    'padding-left': '16px',
                    'padding-right': '16px',
                    'padding-top': '16px',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-image',
                uuid: '65426b5a-4b41-4325-84ef-a9c309d4dde9',
              },
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#121516',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '20px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: 'Zen Buds',
                    title: 'h1',
                  },
                  mobileStyle: { 'font-size': '16px' },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '16px',
                    'padding-right': '16px',
                    'padding-top': '16px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: 'b629f4e0-863b-4b36-90bc-fea8ad7c6907',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '0px',
              'padding-left': '0px',
              'padding-right': '0px',
              'padding-top': '0px',
            },
            uuid: '0080fc35-e6b4-49ef-b98a-0d850942f106',
          },
        ],
        container: {
          style: {
            'background-color': '#ffffff',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            'border-bottom': '0px solid transparent',
            'border-left': '0px solid transparent',
            'border-radius': '0px',
            'border-right': '0px solid transparent',
            'border-top': '0px solid transparent',
            color: '#000000',
            width: '700px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'two-columns-empty',
        uuid: '82a7ed8e-f6df-4c39-94ee-8c6daba60b66',
      },
      {
        columns: [
          {
            'grid-columns': 6,
            modules: [
              {
                descriptor: {
                  computedStyle: {
                    class: 'center fixedwidth fullwidthOnMobile',
                    hideContentOnMobile: false,
                    width: '210px',
                  },
                  image: {
                    alt: '',
                    height: '541px',
                    href: '',
                    percWidth: 60,
                    prefix: '',
                    src: 'https://d15k2d11r6t6rl.cloudfront.net/pub/c524/b1oxpgm8/t98/5e3/5im/Brand-3.png',
                    target: '_blank',
                    width: '540px',
                  },
                  mobileStyle: {
                    'padding-bottom': '48px',
                    'padding-left': '48px',
                    'padding-right': '48px',
                    'padding-top': '48px',
                  },
                  style: {
                    'border-radius': '0px',
                    'padding-bottom': '16px',
                    'padding-left': '16px',
                    'padding-right': '16px',
                    'padding-top': '16px',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-image',
                uuid: '1c81c3a4-16f3-48dd-9aac-a3808247b51d',
              },
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#121516',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '20px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: 'Chill Vibes',
                    title: 'h1',
                  },
                  mobileStyle: { 'font-size': '16px' },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '16px',
                    'padding-right': '16px',
                    'padding-top': '16px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: '83c4b31c-c40a-4b7d-8611-d134431b0a0f',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '0px',
              'padding-left': '0px',
              'padding-right': '0px',
              'padding-top': '0px',
            },
            uuid: 'a9d6c96f-e86b-484d-9f8c-772024ca440c',
          },
          {
            'grid-columns': 6,
            modules: [
              {
                descriptor: {
                  computedStyle: {
                    class: 'center fixedwidth fullwidthOnMobile',
                    hideContentOnMobile: false,
                    width: '210px',
                  },
                  image: {
                    alt: '',
                    height: '541px',
                    href: '',
                    percWidth: 60,
                    prefix: '',
                    src: 'https://d15k2d11r6t6rl.cloudfront.net/pub/c524/b1oxpgm8/jwm/r88/20t/Brand-4.png',
                    target: '_blank',
                    width: '540px',
                  },
                  mobileStyle: {
                    'padding-bottom': '48px',
                    'padding-left': '48px',
                    'padding-right': '48px',
                    'padding-top': '48px',
                  },
                  style: {
                    'border-radius': '0px',
                    'padding-bottom': '16px',
                    'padding-left': '16px',
                    'padding-right': '16px',
                    'padding-top': '16px',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-image',
                uuid: '76da220f-5206-44b9-9e48-2b001b722172',
              },
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#121516',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '20px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: 'Blissful Botanicals',
                    title: 'h1',
                  },
                  mobileStyle: { 'font-size': '16px' },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '16px',
                    'padding-right': '16px',
                    'padding-top': '16px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: '9b983e94-ed63-4a18-9104-f2fd07d0840c',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '0px',
              'padding-left': '0px',
              'padding-right': '0px',
              'padding-top': '0px',
            },
            uuid: '0080fc35-e6b4-49ef-b98a-0d850942f106',
          },
        ],
        container: {
          style: {
            'background-color': '#ffffff',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            'border-bottom': '0px solid transparent',
            'border-left': '0px solid transparent',
            'border-radius': '0px',
            'border-right': '0px solid transparent',
            'border-top': '0px solid transparent',
            color: '#000000',
            width: '700px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'two-columns-empty',
        uuid: '5fad7df2-04c9-4994-acd5-692066e631c2',
      },
      {
        columns: [
          {
            'grid-columns': 12,
            modules: [
              {
                descriptor: {
                  button: {
                    label:
                      '<div class="txtTinyMce-wrapper" style="" data-mce-style=""><p style="word-break:break-word;" data-mce-style="word-break:break-word;">RSVP Here</p></div>',
                    percWidth: 52,
                    style: {
                      'background-color': 'transparent',
                      'border-bottom': '2px solid #0075e0',
                      'border-left': '2px solid #0075e0',
                      'border-radius': '4px',
                      'border-right': '2px solid #0075e0',
                      'border-top': '2px solid #0075e0',
                      color: '#0075e0',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '16px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '200%',
                      'max-width': '100%',
                      'padding-bottom': '12px',
                      'padding-left': '20px',
                      'padding-right': '20px',
                      'padding-top': '12px',
                      width: '60%',
                    },
                    target: '_blank',
                  },
                  computedStyle: { height: 60, hideContentOnMobile: false, width: 362 },
                  mobileStyle: {
                    'padding-bottom': '48px',
                    'padding-left': '24px',
                    'padding-right': '24px',
                    'padding-top': '24px',
                  },
                  style: {
                    'padding-bottom': '48px',
                    'padding-left': '48px',
                    'padding-right': '48px',
                    'padding-top': '48px',
                    'text-align': 'center',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-button',
                uuid: '9b054219-a555-4c7d-a025-573e23ee678b',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '0px',
              'padding-left': '0px',
              'padding-right': '0px',
              'padding-top': '0px',
            },
            uuid: '18f2c7b1-44ab-4a54-8feb-efefe5c450fa',
          },
        ],
        container: {
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            'border-bottom': '0px solid transparent',
            'border-left': '0px solid transparent',
            'border-radius': '0px',
            'border-right': '0px solid transparent',
            'border-top': '0px solid transparent',
            color: '#000000',
            width: '700px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'one-column-empty',
        uuid: '50cd3180-f67b-4c7e-9b71-4335100cad6f',
      },
      {
        columns: [
          {
            'grid-columns': 12,
            modules: [
              {
                descriptor: {
                  computedStyle: {
                    hideContentOnAmp: false,
                    hideContentOnDesktop: false,
                    hideContentOnHtml: false,
                    hideContentOnMobile: false,
                  },
                  paragraph: {
                    computedStyle: { linkColor: '#0075e0', paragraphSpacing: '12px' },
                    html: '<p>Questions? Please refer to our FAQs or emailus at<u> hello@northcannabisco.com</u>.<br/>Copyright © 2024 Dutchie, Inc - All Rights Reserved.<br/>2728 North West Potts Court, Bend OR, 97701</p>',
                    style: {
                      color: '#121516',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '12px',
                      'font-weight': '400',
                      'letter-spacing': '0px',
                      'line-height': '150%',
                      'text-align': 'center',
                    },
                  },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-paragraph',
                uuid: 'd92f13ad-8025-4d20-8582-e03b04e70a71',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '1px solid #e3e7e9',
              'padding-bottom': '48px',
              'padding-left': '48px',
              'padding-right': '48px',
              'padding-top': '48px',
            },
            uuid: 'caa09a39-9d1b-42bc-a0ee-7f9112795f90',
          },
        ],
        container: {
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            'border-bottom': '0px solid transparent',
            'border-left': '0px solid transparent',
            'border-radius': '0px',
            'border-right': '0px solid transparent',
            'border-top': '0px solid transparent',
            color: '#000000',
            width: '700px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'one-column-empty',
        uuid: '701a7386-22d4-4507-9723-e33a3fbf12f6',
      },
    ],
    template: { name: 'template-base', type: 'basic', version: '2.0.0' },
    title: 'empty-dutchie-template',
  },
  comments: {},
};
